import { useEffect } from "react";

function Resume() {
  useEffect(() => {
    document.title = "my resume ⸜(｡ ˃ ᵕ ˂ )⸝♡";
  }, []);

  return (
    <div>
      <p>here's my resume 🌊🪸🐚🐬</p>
      <br/>

      <iframe src="https://drive.google.com/file/d/14MKvvb7ENAp4WdncrsRisiM3MW2UBpta/preview"
        width="640"
        height="825"
        allow="autoplay"
        title="Resume document"
      ></iframe>
    </div>
  );
}

export default Resume;
